import { Star } from "lucide-react";

const FeedbackCard = ({ feedback }) => {
  return (
    <div className="h-64 items-center rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition hover:shadow-md">
      
      {/* Estrelas */}
      <div className="mb-3 flex gap-1 text-center justify-center">
        {[...Array(5)].map((_, index) => (
          <Star
            key={index}
            size={18}
            className={
              index < feedback.rating
                ? "fill-yellow-400 text-yellow-400"
                : "text-gray-300"
            }
          />
        ))}
      </div>

      <p className="text-gray-600 leading-relaxed text-center">
        “{feedback.message}”
      </p>

      <div className="mt-6">
        <p className="font-semibold text-gray-900 text-center">
          {feedback.name}
        </p>
      </div>
    </div>
  );
};

export default FeedbackCard;
 